/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, OnDestroy, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subscription } from 'rxjs';

export interface IStyleValues {
  maxWidth?: string;
  color?: string;
  fontSize?: string;
}

@Component({
  selector: 'ic-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent implements OnDestroy {
  titleStyleString: string | null = null;
  contentStyleString: string | null = null;
  content2StyleString: string | null = null;
  content3StyleString: string | null = null;
  template: TemplateRef<any> | null = null;
  userAssigned: string | null = null;
  disableAcceptButton = false;
  customTemplate: TemplateRef<any> | null = null;

  private userAssignedSubscription: Subscription | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      titleStyle?: IStyleValues;
      content: string;
      contentStyle?: IStyleValues;
      content2?: string;
      content2Style?: IStyleValues;
      content3?: string;
      content3Style?: IStyleValues;
      buttonCancel: string;
      buttonAccept: string;
      buttonAcceptAndAction: string;
      template?: TemplateRef<any>;
      userAssignedSubject: BehaviorSubject<string | null>;
      customTemplate?: TemplateRef<any>;
    }
  ) {
    if (data.titleStyle) {
      this.titleStyleString = '';
      this.titleStyleString += data.titleStyle.color
        ? `color: ${data.titleStyle.color};`
        : '';
      this.titleStyleString += data.titleStyle.maxWidth
        ? `max-width: ${data.titleStyle.maxWidth};`
        : '';
      this.titleStyleString += data.titleStyle.fontSize
        ? `font-size: ${data.titleStyle.fontSize};`
        : '';
    }
    if (data.contentStyle) {
      this.contentStyleString = '';
      this.contentStyleString += data.contentStyle.color
        ? `color: ${data.contentStyle.color};`
        : '';
      this.contentStyleString += data.contentStyle.maxWidth
        ? `max-width: ${data.contentStyle.maxWidth};`
        : '';
      this.contentStyleString += data.contentStyle.fontSize
        ? `font-size: ${data.contentStyle.fontSize};`
        : '';
    }
    if (data.content2Style) {
      this.content2StyleString = '';
      this.content2StyleString += data.content2Style.color
        ? `color: ${data.content2Style.color};`
        : '';
      this.content2StyleString += data.content2Style.maxWidth
        ? `max-width: ${data.content2Style.maxWidth};`
        : '';
      this.content2StyleString += data.content2Style.fontSize
        ? `font-size: ${data.content2Style.fontSize};`
        : '';
    }
    if (data.content3Style) {
      this.content3StyleString = '';
      this.content3StyleString += data.content3Style.color
        ? `color: ${data.content3Style.color};`
        : '';
      this.content3StyleString += data.content3Style.maxWidth
        ? `max-width: ${data.content3Style.maxWidth};`
        : '';
      this.content3StyleString += data.content3Style.fontSize
        ? `font-size: ${data.content3Style.fontSize};`
        : '';
    }
    this.template = data.template || null;
    this.customTemplate = data.customTemplate || null;

    this.userAssignedSubscription = data.userAssignedSubject?.subscribe(
      (newUserAssigned: string | null) => {
        this.userAssigned = newUserAssigned;
        this.updateContent();
      }
    );
  }

  ngOnDestroy(): void {
    // Asegura cancelar la suscripción para evitar fugas de memoria
    this.userAssignedSubscription?.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  cancel($event: Event): void {
    $event.preventDefault();
    this.dialogRef.close({ result: false });
  }

  accept($event: Event): void {
    $event.preventDefault();
    this.dialogRef.close({ result: true, action: false });
  }

  acceptAndAction($event: Event): void {
    $event.preventDefault();
    this.dialogRef.close({ result: true, action: true });
  }

  setDisableAcceptButton(disable: boolean): void {
    this.disableAcceptButton = disable;
  }

  /**
   * Actualiza el email en el dialogo de Asignar expediente/solicitud a..
   */
  private updateContent(): void {
    this.data.content = this.replaceEmailInContent(
      this.data.content,
      this.userAssigned
    );
  }

  /**
   * Reemplaza el correo por el del nuevo usuario seleccionado
   */
  private replaceEmailInContent(
    content: string,
    newEmail: string | null
  ): string {
    // Regex que captura correos electrónicos con varios formatos
    const emailRegex =
      /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+/g;
    return content.replace(emailRegex, newEmail || ''); // Reemplaza todos los correos que coinciden
  }
}
